const Experimental = () => import("./views/Experimental.vue");

export default [
  {
    path: "/experimental",
    name: "experimental",
    component: Experimental,
    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
